export const CONFIGURATOR_KEY = {
    N4G: '4g',
    N5G: '5g',
};

export const OFFER_BLOCKED = 12782;
